<template>
  <div class="myTask">
    <el-card>
      <!-- 头部 -->
      <el-row :gutter="24">
        <el-col :span="8">
          <div style="font-size: 30px">
            我的执行情况&nbsp;&nbsp;&nbsp;
            <span style="font-size: 26px">{{ time }}</span>
          </div>
        </el-col>
        <el-col :span="5" :offset="11">
          <el-select
            v-model="planid"
            style="width: 100%"
            filterable
            placeholder="请选择"
            @change="changePlanid"
          >
            <el-option
              v-for="item in list"
              :key="item.zwpp01"
              :label="item.zwpp03"
              :value="item.zwpp01"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="22" :offset="0" style="font-size: 16px; margin: 10px 0">
          您一共拥有{{
            myFileData.filter((ele) => ele.zwpm08 === 2).length
          }}个BIM模型，{{
            myFileData.filter((ele) => ele.zwpm08 === 3).length
          }}张图纸，{{
            myFileData.filter((ele) => ele.zwpm08 === 4).length
          }}个文档
        </el-col>
      </el-row>
      <!-- echarts -->
      <el-row :gutter="24" style="height: 230px">
        <el-col :span="3" :offset="0" style="text-align: right">
          <div class="flex" style="font-size: 14px; justify-content: left">
            <h2>总任务数</h2>
            <h1
              style="
                font-weight: 700;
                color: #000;
                font-size: 32px;
                margin-left: 10px;
              "
            >
              {{ zong }}
            </h1>
          </div>
          <div
            class="flex"
            style="font-size: 14px; justify-content: left; margin: 20px 0"
          >
            <h2>进行中任务数</h2>
            <h1
              style="
                font-weight: 700;
                color: #8666ba;
                font-size: 32px;
                margin-left: 10px;
              "
            >
              {{ jinxing }}
            </h1>
          </div>
          <div class="flex" style="font-size: 14px; justify-content: left">
            <h2>已完成任务数</h2>
            <h1
              style="
                font-weight: 700;
                color: #42b789;
                font-size: 32px;
                margin-left: 10px;
              "
            >
              {{ yiwancheng }}
            </h1>
          </div>
        </el-col>
        <el-col :span="3" :offset="0" style="text-align: right">
          <div
            class="flex"
            style="
              font-size: 14px;
              justify-content: left;
              margin: 20px 0;
              margin-top: 60px;
            "
          >
            <h2>未启动任务数</h2>
            <h1
              style="
                font-weight: 700;
                color: #f98017;
                font-size: 32px;
                margin-left: 10px;
              "
            >
              {{ weiqi }}
            </h1>
          </div>
          <div
            class="flex"
            style="font-size: 14px; justify-content: left; margin: 20px 0"
          >
            <h2>已延期任务数</h2>
            <h1
              style="
                font-weight: 700;
                color: #ff0000;
                font-size: 32px;
                margin-left: 10px;
              "
            >
              {{ yiyanqi }}
            </h1>
          </div>
        </el-col>
        <el-col :span="6" :offset="0" style="height: 100%">
          <v-chart
            theme="macarons"
            id="chart1"
            style="width: 100%"
            :options="polar"
          />
        </el-col>
        <el-col :span="6" :offset="0" style="height: 100%">
          <v-chart
            theme="macarons"
            id="chart2"
            style="width: 100%"
            :options="polar1"
          />
        </el-col>
        <el-col :span="6" :offset="0" style="height: 100%">
          <v-chart
            theme="macarons"
            id="chart3"
            style="width: 100%"
            :options="polar2"
          />
        </el-col>
      </el-row>
      <!-- 风险预警 -->
      <el-row :gutter="24">
        <el-col :span="3">
          <div
            style="
              width: 60px;
              height: 30px;
              background-color: red;
              border-radius: 4px;
              float: left;
            "
          ></div>
          <p style="margin: 5px 0 0 10px; float: left">风险预警</p>
        </el-col>
        <el-col :span="10" :offset="11">
          <el-row class="flex" style="">
            <el-input v-model="searchword" placeholder="请输入内容"></el-input>
            <el-button icon="el-icon-search" @click="ZjwjMyToDo"></el-button>
            <el-button
              style="background-color: #000; color: #fff"
              @click="changeType(1)"
              >待办任务</el-button
            >
            <el-button
              style="background-color: #f59a23; color: #fff"
              @click="changeType(2)"
              >逾期任务</el-button
            >
            <el-button type="success" @click="changeType(3)"
              >已完成任务</el-button
            >
            <el-button type="danger" @click="changeType(4)">驳回任务</el-button>
          </el-row>
        </el-col>
      </el-row>
      <!-- 表格 -->
      <el-row :gutter="24" style="margin-top: 15px">
        <el-table
          :data="tableList"
          ref="multipleTable"
          tooltip-effect="dark"
          style="width: 100%"
          height="600px"
          row-key="zwpd01"
          :row-class-name="tableRowClassName"
          :highlight-current-row="true"
          default-expand-all
          :tree-props="{ children: 'children' }"
          v-loading="loading"
          v-show="type === 1"
        >
          <el-table-column property="zwpd04" label="任务名称">
            <template slot-scope="scope">
              <span>{{ scope.row.zwpd04 }}</span>

              <span
                v-if="scope.row.isReturn === 1 ? true : false"
                :style="{ color: 'red' }"
              >
                驳回
              </span>
            </template>
          </el-table-column>
          <el-table-column label="责任人" align="center" prop="fzr">
          </el-table-column>
          <el-table-column label="审核人" align="center" prop="shr">
          </el-table-column>
          <el-table-column property="zwpd14" label="里程碑">
            <template slot-scope="scope">
              <el-switch
                disabled
                v-model="scope.row.zwpd14"
                :active-value="1"
                :inactive-value="0"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column property="zwpd05" label="计划开始时间">
          </el-table-column>
          <el-table-column property="zwpd06" label="计划完成时间">
          </el-table-column>
          <el-table-column property="zwpd11" label="备注"> </el-table-column>
          <el-table-column label="执行任务">
            <template slot-scope="scope">
              <el-button
                type="success"
                size="mini"
                v-if="
                  !scope.row.zwpd09 &&
                  scope.row.children.length === 0 &&
                  $store.state.uid == scope.row.fzId
                "
                @click="ZjwjStartPlan(scope.row)"
                >启动</el-button
              >
            </template>
          </el-table-column>
          <el-table-column property="state" label="执行状态">
            <template slot-scope="scope">
              <p
                :style="{
                  background: scope.row.isDanger === 1 ? 'red' : '',
                  textAlign: 'center',
                  color: '#000',
                  height: '28px',
                  lineHeight: '28px',
                  borderRadius: '10px',
                }"
              >
                {{ scope.row.state }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="成果管理">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="dialogTableVisibleOpen(scope.row)"
                v-if="scope.row.children.length === 0 && scope.row.zwpd09"
                >管理</el-button
              >
              <span v-else>----</span>
            </template>
          </el-table-column>
          <el-table-column label="完成进度" width="150px">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                v-if="scope.row.children.length === 0 && scope.row.zwpd09"
                @click="openRecord(scope.row)"
              >
                {{ scope.row.wcjd }}
              </el-button>
              <span v-else>----</span>
            </template>
          </el-table-column>
        </el-table>

        <el-table
          :data="tableList"
          ref="multipleTable"
          tooltip-effect="dark"
          style="width: 100%"
          height="600px"
          row-key="zwpd01"
          :highlight-current-row="true"
          default-expand-all
          :tree-props="{ children: 'children' }"
          v-loading="loading"
          v-show="type === 2"
        >
          <el-table-column property="zwpd04" label="任务名称">
            <template slot-scope="scope">
              <span>{{ scope.row.zwpd04 }}</span>

              <span
                v-if="scope.row.isReturn === 1 ? true : false"
                :style="{ color: 'red' }"
              >
                驳回
              </span>
            </template>
          </el-table-column>
          <el-table-column label="责任人" align="center" prop="fzr">
          </el-table-column>
          <el-table-column label="审核人" align="center" prop="shr">
          </el-table-column>
          <el-table-column property="zwpd05" label="计划开始时间">
          </el-table-column>
          <el-table-column property="zwpd06" label="计划完成时间">
          </el-table-column>
          <el-table-column property="zwpd07" label="最迟完成时间">
          </el-table-column>
          <el-table-column property="zwpd11" label="备注"> </el-table-column>
          <el-table-column property="state" label="执行状态">
            <template slot-scope="scope">
              <span
                :style="{ color: scope.row.isDanger === 1 ? 'red' : 'green' }"
              >
                {{ scope.row.state }}
              </span>
            </template>
          </el-table-column>
        </el-table>

        <el-table
          :data="tableList"
          ref="multipleTable"
          tooltip-effect="dark"
          style="width: 100%"
          height="600px"
          row-key="zwpd01"
          :highlight-current-row="true"
          default-expand-all
          :tree-props="{ children: 'children' }"
          v-loading="loading"
          v-show="type === 3"
        >
          <el-table-column property="zwpd04" label="任务名称">
            <template slot-scope="scope">
              <span>{{ scope.row.zwpd04 }}</span>

              <span
                v-if="scope.row.isReturn === 1 ? true : false"
                :style="{ color: 'red' }"
              >
                驳回
              </span>
            </template>
          </el-table-column>
          <el-table-column label="责任人" align="center" prop="fzr">
          </el-table-column>
          <el-table-column label="审核人" align="center" prop="shr">
          </el-table-column>
          <el-table-column property="zwpd05" label="计划开始时间">
          </el-table-column>
          <el-table-column property="zwpd06" label="计划完成时间">
          </el-table-column>
          <el-table-column property="zwpd07" label="最迟完成时间">
          </el-table-column>
          <el-table-column property="zwpd11" label="备注"> </el-table-column>
          <el-table-column property="state" label="执行状态">
            <template slot-scope="scope">
              <span
                :style="{ color: scope.row.isDanger === 1 ? 'red' : 'green' }"
              >
                {{ scope.row.state }}
              </span>
            </template>
          </el-table-column>
          <el-table-column property="state" label="审核状态">
            <template slot-scope="scope">
              <span
                :style="{ color: scope.row.isDanger === 1 ? 'red' : 'green' }"
              >
                {{ scope.row.state }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="成果管理">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="dialogTableVisibleOpen(scope.row)"
                v-if="scope.row.children.length === 0"
                >管理</el-button
              >
              <span v-else>--------</span>
            </template>
          </el-table-column>
        </el-table>

        <el-table
          :data="tableList"
          ref="multipleTable"
          tooltip-effect="dark"
          style="width: 100%"
          height="600px"
          row-key="zwpd01"
          :highlight-current-row="true"
          default-expand-all
          :tree-props="{ children: 'children' }"
          v-loading="loading"
          v-show="type === 4"
        >
          <el-table-column property="zwpd04" label="任务名称">
            <template slot-scope="scope">
              <span>{{ scope.row.zwpd04 }}</span>

              <span
                v-if="scope.row.isReturn === 1 ? true : false"
                :style="{ color: 'red' }"
              >
                驳回
              </span>
            </template>
          </el-table-column>
          <el-table-column label="责任人" align="center" prop="fzr">
          </el-table-column>
          <el-table-column label="审核人" align="center" prop="shr">
          </el-table-column>
          <el-table-column property="zwpd14" label="里程碑">
            <template slot-scope="scope">
              <el-switch
                disabled
                v-model="scope.row.zwpd14"
                :active-value="1"
                :inactive-value="0"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column property="zwpd05" label="计划开始时间">
          </el-table-column>
          <el-table-column property="zwpd06" label="计划完成时间">
          </el-table-column>
          <el-table-column property="zwpd11" label="备注"> </el-table-column>
          <el-table-column label="执行任务">
            <template slot-scope="scope">
              <el-button
                type="success"
                size="mini"
                v-if="!scope.row.zwpd09 && scope.row.children.length === 0"
                @click="ZjwjStartPlan(scope.row)"
                >启动</el-button
              >
            </template>
          </el-table-column>
          <el-table-column property="state" label="执行状态">
            <template slot-scope="scope">
              <span
                :style="{ color: scope.row.isDanger === 1 ? 'red' : 'green' }"
              >
                {{ scope.row.state }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="成果管理">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="dialogTableVisibleOpen(scope.row)"
                v-if="scope.row.children.length === 0"
                >管理</el-button
              >
              <span v-else>--------</span>
            </template>
          </el-table-column>
          <el-table-column label="完成进度" width="150px">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                v-if="
                  scope.row.children.length === 0 &&
                  scope.row.zwpd09
                "
                @click="openRecord(scope.row)"
              >
                {{ scope.row.wcjd }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="驳回信息" width="150px">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="GetPlanAuditOpen(scope.row)"
              >
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-card>
    <!-- 管理 -->
    <el-dialog
      :close-on-click-modal="false"
      title="成果管理"
      :visible.sync="dialogTableVisible"
      center
      width="50%"
    >
      <el-row :gutter="24">
        <el-col :span="12">
          <el-button type="primary" @click="changUploadType(1)"
            >BIM模型</el-button
          >
          <el-button
            type="primary"
            @click="changUploadType(3)"
            style="background-color: #8080ff"
            >图纸</el-button
          >
          <el-button type="info" @click="changUploadType(4)"
            >文档附件</el-button
          >
          <el-button
            type="danger"
            style="margin-top: 20px"
            @click="uploadModelOpen"
            v-if="type !== 3"
            >上传</el-button
          >
        </el-col>
        <el-col :span="8" :offset="4" class="flex">
          <el-input v-model="input" placeholder="请输入文件名"></el-input>
          <el-button icon="el-icon-search"></el-button>
        </el-col>
      </el-row>
      <h2>{{ uploadTypeName }}</h2>
      <el-table :data="uploadList" v-loading="uploadListLoading">
        <el-table-column
          align="center"
          property="zwpm03"
          label="文件名称"
        ></el-table-column>
        <el-table-column align="center" property="user04" label="上传人">
        </el-table-column>
        <el-table-column
          align="center"
          property="zwpm05"
          label="备注"
        ></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              v-if="scope.row.zwpm08 === 1 || scope.row.zwpm08 === 3"
              size="mini"
              @click="viewModelOpen(scope.row)"
              >浏览</el-button
            >
            <el-button
              type="success"
              size="mini"
              @click="downloadModel(scope.row)"
              >下载</el-button
            >
            <el-button
              v-if="type !== 3"
              type="danger"
              size="mini"
              @click="DelZjwjPlanModel(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 记录列表 -->
    <el-dialog
      :close-on-click-modal="false"
      title="记录列表"
      :visible.sync="record"
      center
      width="50%"
    >
      <el-button
        type="primary"
        size="mini"
        v-if="$store.state.uid == fzId"
        @click="AddZjwjPlanRecordOpen"
        >添加记录</el-button
      >
      <el-table :data="recordList" style="width: 100%">
        <el-table-column
          align="center"
          property="zwpr04"
          label="进度"
        ></el-table-column>
        <el-table-column align="center" property="zwpr05" label="提交说明">
        </el-table-column>
        <el-table-column
          align="center"
          property="zwpr06"
          label="创建时间"
        ></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 添加记录 -->
    <el-dialog
      :close-on-click-modal="false"
      title="添加记录"
      :visible.sync="addRecord"
      center
      width="30%"
    >
      <el-row
        style="display: flex; justify-content: center; align-items: center"
      >
        <el-col :span="4">进度预估：:</el-col>
        <el-col :span="16"
          ><el-progress
            :text-inside="true"
            :stroke-width="30"
            :percentage="zjwj_planrecord.zwpr04"
          ></el-progress
        ></el-col>
        <el-col :span="3">
          <el-input v-model="zjwj_planrecord.zwpr04"></el-input>
        </el-col>
      </el-row>
      <el-row
        style="display: flex; justify-content: center; align-items: center"
      >
        <el-col :span="4">提交说明:</el-col>
        <el-col :span="20">
          <el-input type="textarea" v-model="zjwj_planrecord.zwpr05"></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6" :offset="5">
          <el-button type="danger">取消</el-button>
        </el-col>
        <el-col :span="6" :offset="2">
          <el-button type="success" @click="AddZjwjPlanRecord">{{
            zjwj_planrecord.zwpr04 == 100 ? "报审" : "确定"
          }}</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 上传文件 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="uploadTypeName"
      :visible.sync="uploadModel"
      center
      width="50%"
    >
      <el-form
        ref="form"
        :model="ziwj_planmodel"
        label-width="80px"
        v-loading="uploadLoading"
      >
        <el-form-item label="文件名称">
          <el-input v-model="ziwj_planmodel.zwpm03"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="ziwj_planmodel.zwpm05"></el-input>
        </el-form-item>
        <!-- -------- -->
        <el-form-item
          v-if="uploadType == 1 || uploadType == 3"
          label="轻量化"
          label-width="100px"
        >
          <el-upload
            class="upload-demo"
            :action="actionS"
            :auto-upload="false"
            :on-change="uploadChange"
          >
            <el-button type="primary" size="small">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item
          v-if="uploadType == 1 || uploadType == 3"
          label="源文件"
          label-width="100px"
        >
          <el-upload
            class="upload-demo"
            :action="actionS"
            :on-change="uploadChange2"
            :auto-upload="false"
          >
            <el-button type="primary" size="small">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-row>
          <el-col :span="4" :offset="20">
            <el-button
              type="success"
              size="small"
              v-if="uploadType == 1 || uploadType == 3"
              @click="uploadQLHModel"
              >确定上传至服务器</el-button
            >
          </el-col>
        </el-row>
        <!-- -------- -->
        <el-form-item label="上传" v-if="uploadType == 2 || uploadType == 4">
          <el-upload
            class="upload-demo"
            :action="uploadType == 4 ? actionS : actionS2"
            :headers="importHeaders"
            :data="ziwj_planmodel"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
          >
            <el-button size="small">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 上传文件类型 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="uploadTypeName"
      :visible.sync="uploadModelType"
      center
      width="30%"
      top="2%"
    >
      <div class="changUpload">
        <div class="ZIP" @click="updataModelShow">
          <p>
            {{
              uploadType == 1 || uploadType == 2
                ? "上传svf文件"
                : "上传轻量化图纸"
            }}
          </p>
          <img src="@/assets/img/upload.png" alt />
          <p>最高支持2021版本文件</p>
        </div>
        <div class="REVIT" @click="updataModelShowREVIT">
          <p>
            {{
              uploadType == 1 || uploadType == 2
                ? "上传REVIT/NAVISWORKS文件并转化"
                : "上传.dwg图纸"
            }}
          </p>
          <img src="@/assets/img/upload.png" alt />
          <p>最高支持2021版本文件</p>
        </div>
      </div>
    </el-dialog>
    <!-- 模型展示 -->
    <el-drawer
      title="模型展示"
      :visible.sync="viewModelIsShow"
      direction="ttb"
      size="80%"
    >
      <div id="MyViewerDiv" class="model"></div>
    </el-drawer>
    <!-- 驳回信息展示 -->
    <el-dialog
      :close-on-click-modal="false"
      title="驳回信息"
      :visible.sync="GetPlanAuditIsShow"
      fullscreen
    >
      <el-row>
        <el-col :span="6">
          <el-card class="box-card">
            <div style="width: 100%; height: 80vh; overflow: auto">
              <div style="height: 80px; line-height: 80px">
                <span style="font-size: 32px">驳回批次：</span>
                <el-select
                  style="float: right"
                  v-model="bohuiId"
                  placeholder="请选择驳回"
                  @change="changeBohui"
                >
                  <el-option
                    v-for="item in bohuiList"
                    :key="item.zwpa01"
                    :label="item.zwpa07"
                    :value="item.zwpa01"
                  >
                  </el-option>
                </el-select>
              </div>
              <el-collapse v-model="activeNames">
                <el-collapse-item title="驳回批注" name="1">
                  <div>{{ bhMsg }}</div>
                </el-collapse-item>
              </el-collapse>

              <!-- 模型列表 -->
              <h2 v-if="ModelList" style="font-size: 28px">模型列表</h2>
              <el-table
                style="margin-top: 10px"
                :data="ModelList"
                v-if="ModelList"
              >
                <el-table-column
                  property="zwpm03"
                  label="名称"
                ></el-table-column>
                <el-table-column
                  property="zwpm07"
                  label="创建时间"
                ></el-table-column>
                <el-table-column>
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      size="mini"
                      @click="viewModel(scope.row)"
                      >查看</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <!-- 图纸列表 -->
              <h2 v-if="DrawList" style="font-size: 28px">图纸列表</h2>
              <el-table
                style="margin-top: 10px"
                :data="DrawList"
                v-if="DrawList"
              >
                <el-table-column
                  property="zwpm03"
                  label="名称"
                ></el-table-column>
                <el-table-column
                  property="zwpm07"
                  label="创建时间"
                ></el-table-column>
                <el-table-column>
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      size="mini"
                      @click="viewModel(scope.row)"
                      >查看</el-button
                    >
                  </template>
                </el-table-column></el-table
              >
              <!-- 文档列表 -->
              <h2 v-if="FileList" style="font-size: 28px">文档列表</h2>
              <el-table
                style="margin-top: 10px"
                :data="FileList"
                v-if="FileList"
              >
                <el-table-column
                  property="zwpm03"
                  label="名称"
                ></el-table-column>
                <el-table-column
                  property="zwpm07"
                  label="创建时间"
                ></el-table-column>
                <el-table-column>
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      size="mini"
                      @click="viewDocument(scope.row)"
                      >查看</el-button
                    >
                  </template>
                </el-table-column></el-table
              >
            </div>
          </el-card>
        </el-col>
        <el-col :span="18">
          <!-- 模型图纸展示 -->
          <el-card
            v-if="!isDocumentShow && !modelDB && modelisShow"
            class="box-card"
          >
            <div style="width: 100%; height: 80vh; overflow: auto">
              <!-- 11111 -->
              <div style="width: 100%; height: 700px; position: relative">
                <el-button
                  type="danger"
                  size="mini"
                  style="position: absolute; top: 10px; z-index: 999"
                  v-show="modelLoad"
                  @click="viewpointSave"
                  >视点数据</el-button
                >
                <el-button
                  type="danger"
                  size="mini"
                  v-show="modelLoad && !isTuZhi"
                  @click="pengzhuang"
                  style="
                    position: absolute;
                    left: 100px;
                    top: 10px;
                    z-index: 999;
                  "
                  >碰撞数据</el-button
                >
                <el-button
                  type="danger"
                  size="mini"
                  v-show="modelLoad && !isTuZhi"
                  style="position: absolute; left: 200px; top: 10px; z-index: 2"
                  @click="modelDuibi(1)"
                >
                  模型对比
                </el-button>
                <div id="MyViewerDiv" class="model"></div>
                <canvas id="snapshot" hidden></canvas>
                <!-- 碰撞检查 -->
                <div class="crashCheck_box" id="crashCheckDiv">
                  <div class="box_title">碰撞检查</div>
                  <div class="btnClose" onclick="CrashCheck.close()">×</div>
                  <div class="box_content">
                    <div class="tab_title">
                      <ul id="crashCheck_tabs" class="clearfix">
                        <li
                          class="current"
                          style="width: 33%"
                          onclick="CrashCheck.select(this)"
                        >
                          <a href="#" title="选择构件">选择构件</a>
                        </li>
                        <li
                          style="width: 33%"
                          onclick="CrashCheck.select(this)"
                        >
                          <a href="#" title="碰撞结果">碰撞结果</a>
                        </li>
                        <li
                          style="width: 33%"
                          @click="GetCrashCheck"
                          onclick="CrashCheck.select(this)"
                        >
                          <a href="#" title="碰撞结果">碰撞报告</a>
                        </li>
                      </ul>
                    </div>
                    <div id="menu_crashCheck_content_box">
                      <div id="crashCheck_tab1" class="menu_table dis-bok">
                        <div class="box">
                          <div class="tree">
                            <ul id="crashCheck_tree1" class="ztree"></ul>
                          </div>
                          <el-button
                            style="width: 94%; margin-left: 5%"
                            size="small"
                            type="primary"
                            onclick="CrashCheck.export('crashCheck_tree1')"
                          >
                            导入目前选择构件
                          </el-button>
                        </div>
                        <div class="box">
                          <div class="tree">
                            <ul id="crashCheck_tree2" class="ztree"></ul>
                          </div>
                          <el-button
                            style="width: 94%; margin-left: 5%"
                            size="small"
                            type="primary"
                            onclick="CrashCheck.export('crashCheck_tree2')"
                            >导入目前选择构件</el-button
                          >
                        </div>
                        <el-button
                          style="width: 94%; margin-left: 3%"
                          size="small"
                          type="primary"
                          onclick="CrashCheck.todo()"
                          >进行碰撞</el-button
                        >
                      </div>
                      <div id="crashCheck_tab2" class="menu_table dis-none">
                        <div class="tree" style="height: 94%">
                          <ul
                            id="crashCheck_resultTree"
                            class="ztree"
                            style="height: 90%"
                          ></ul>
                          <div id="rMenu_crashCheck" class="rMenu pos-fixed">
                            <ul id="rShowMenu_crashCheck">
                              <li
                                id="cc_m_del"
                                class="dis-lis-item"
                                onclick="CrashCheck.removeTreeNode()"
                              >
                                删除
                              </li>
                            </ul>
                          </div>
                        </div>
                        <el-button
                          style="width: 94%; margin-left: 5%"
                          size="small"
                          type="primary"
                          @click="AddCrashCheckOpen"
                        >
                          保存
                        </el-button>
                      </div>
                      <div id="crashCheck_tab3" class="menu_table dis-none">
                        <div class="tree">
                          <ul
                            id="crashCheck_baoGaoTree"
                            class="ztree"
                            style="height: 90%"
                          ></ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 视点保存 -->
                <div
                  id="div_viewpoint"
                  class="m-right-sidebar"
                  style="right: 10%; height: 670px; top: 10%; display: none"
                >
                  <h2 class="sdbcName">视点保存</h2>
                  <div
                    class="btnClose close_bt_p"
                    onclick="ZJWJViewPoint.hiddenViewPoint();"
                  >
                    ×
                  </div>
                  <div class="body_viewpoint">
                    <div
                      id="viewpointUser"
                      style="width: 100%; max-height: 10%; overflow: auto"
                    ></div>
                    <ul
                      id="treeDemo_viewpoint"
                      class="treeDemo_viewpoint ztree"
                    ></ul>
                  </div>
                  <div class="w-h-bg-cor">
                    <el-button
                      type="primary"
                      id="vp-btn-mark"
                      data-placement="bottom"
                      data-toggle="tooltip"
                      title="涂鸦"
                      size="small"
                      onclick="ZJWJViewPoint.showMarkTool()"
                      >涂鸦</el-button
                    >

                    <el-button
                      type="primary"
                      id="vp-btn-save"
                      data-placement="bottom"
                      data-toggle="tooltip"
                      size="small"
                      title="保存"
                      onclick="ZJWJViewPoint.onSaveLayer()"
                      >保存</el-button
                    >
                  </div>
                  <div id="rMenu_viewpoint" class="rMenu pos-fixed">
                    <ul id="rShowMenu_viewpoint">
                      <li
                        id="vp_m_add"
                        class="dis-lis-item"
                        onclick="ZJWJViewPoint.addTreeNode()"
                      >
                        新建视点目录
                      </li>
                      <li
                        id="vp_m_del"
                        class="dis-lis-item"
                        onclick="ZJWJViewPoint.removeTreeNode()"
                      >
                        删除
                      </li>
                      <li
                        id="vp_m_ren"
                        class="dis-lis-item"
                        onclick="ZJWJViewPoint.renameTreeNode()"
                      >
                        重命名
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- 11111 -->
            </div>
          </el-card>
          <!-- 这里是模型对比 -->
          <el-card
            v-if="!modelisShow && !isDocumentShow && modelDB"
            class="box-card"
          >
            <div class="ModelCompare">
              <el-button
                type="danger"
                size="mini"
                style="position: absolute; right: 0px; z-index: 2"
                @click="modelDuibi(2)"
              >
                关闭
              </el-button>
              <div id="model1" class="model"></div>
              <div class="myBorder">
                <el-button
                  @click="ModelCompare"
                  class="myborder-el-button"
                  title="比对"
                  icon="el-icon-s-help"
                  circle
                ></el-button>
                <div class="divs">
                  <div title="删除">删除</div>
                  <div title="增加">增加</div>
                  <div title="变更前">变更前</div>
                  <div title="变更后">变更后</div>
                </div>
              </div>
              <div id="model2" class="model model3"></div>
              <el-select
                class="modelListOne"
                v-model="model1"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in ModelList"
                  :key="item.zwpm01"
                  :label="item.zwpm03"
                  :value="item.zwpm01"
                  @click.native="model1Change(item)"
                ></el-option>
              </el-select>
              <el-select
                class="modelListTwo"
                v-model="model2"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in ModelList"
                  @click.native="model2Change(item)"
                  :key="item.zwpm01"
                  :label="item.zwpm03"
                  :value="item.zwpm01"
                ></el-option>
              </el-select>
            </div>
          </el-card>
          <!-- 文档显示 -->
          <el-row
            style="padding: 0"
            v-if="isDocumentShow && !modelisShow && !modelDB"
          >
            <el-col :span="12">
              <el-card class="box-card">
                <div style="width: 100%; height: 80vh; overflow: auto">
                  <iframe
                    width="100%"
                    height="100%"
                    :src="iframeUrl"
                    frameborder="0"
                  ></iframe>
                </div>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card class="box-card">
                <div style="width: 100%; height: 80vh; overflow: auto">
                  <el-table :data="fileAuditList">
                    <el-table-column
                      property="user04"
                      label="创建人"
                    ></el-table-column>
                    <el-table-column
                      property="zwfa05"
                      label="创建时间"
                    ></el-table-column>

                    <el-table-column>
                      <template slot-scope="scope">
                        <el-button
                          type="primary"
                          size="mini"
                          @click="viewFileAudit(scope.row)"
                          >查看</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                  <div v-if="bianjiAudit">
                    <el-row style="margin-top: 10px">
                      <el-col :span="2" :offset="22">
                        <el-button
                          type="danger"
                          size="mini"
                          @click="bianjiAudit = false"
                          >关闭</el-button
                        >
                      </el-col>
                    </el-row>
                    <div v-html="zwfa03">
                      {{ zwfa03 }}
                    </div>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 添加碰撞报告 -->
    <el-dialog
      :close-on-click-modal="false"
      title="添加碰撞报告"
      :visible.sync="AddCrashCheckIsShow"
      width="40%"
      top="2%"
    >
      <el-form ref="form" :model="zjwj_crashcheck" label-width="150px">
        <el-form-item label="名称">
          <el-input
            type="text"
            v-model="zjwj_crashcheck.zwcc03"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-model="zjwj_crashcheck.zwcc05"
            style="width: 100%"
          ></el-input>
        </el-form-item> </el-form
      ><span slot="footer" class="dialog-footer">
        <el-button @click="AddCrashCheckIsShow = false">取 消</el-button>
        <el-button type="primary" @click="AddCrashCheck">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { download } from "@/tools/tool.js";
import {
  GetZjwjProjectPlan,
  ZjwjMyToDo,
  ZjwjStartPlan,
  AddZjwjPlanRecord,
  GetZjwjPlanRecord,
  GetZjwjPlanModel,
  ZjwjUploadModelFile,
  DelZjwjPlanModel,
  GetZjwjMyFile,
  GetPlanAudit,
  Office2Pdf,
  GetFileAudit,
  GetCrashCheck,
  AddCrashCheck,
} from "@/setAxios.js";
export default {
  name: "",
  props: {},
  data() {
    return {
      fileList: [],
      uploadModelType: false,
      activeNames: ["1"],
      modelDB: false,
      zjwj_crashcheck: {
        zwcc01: "",
        zwcc02: "",
        zwcc03: "",
        zwcc04: "",
        zwcc05: "",
        zwcc06: "",
        zwcc07: new Date(),
      },
      AddCrashCheckIsShow: false,
      localStorage: {
        id: localStorage.id,
      },
      // -------驳回信息
      isTuZhi: false,
      modelisShow: false,
      isDocumentShow: false,
      zwpm01: "",
      modelLoad: false,
      GetPlanAuditIsShow: false,
      bohuiList: [],
      bohuiId: "",
      DrawList: [],
      FileList: [],
      ModelList: [],
      iframeUrl: "",
      fileAuditList: [],
      bianjiAudit: false,
      zwfa03: "",
      // --------
      myFileData: [],
      zong: 0,
      weiqi: 0,
      jinxing: 0,
      yiyanqi: 0,
      yiwancheng: 0,
      wqdzc: 0,
      wqdyq: 0,
      zxzzc: 0,
      zxzyq: 0,
      ywczc: 0,
      ywcyq: 0,
      wxrw: 0,
      zcrw: 0,
      viewer: null,
      viewModelIsShow: false,
      modelUrl: "",
      uploadList: [],
      uploadLoading: false,
      uploadListLoading: false,
      actionS: this.$store.state.baseUrl + "/api/ZjwjUploadModelFile",
      actionS2: this.$store.state.baseUrl + "/api/ZjwjUploadModelRvt",
      importHeaders: { token: localStorage.getItem("token") },
      ziwj_planmodel: {
        zwpm01: "",
        zwpm02: "",
        zwpm03: "",
        zwpm04: "",
        zwpm05: "",
        zwpm06: localStorage.id,
        zwpm07: new Date(),
        zwpm08: "",
        cid: localStorage.pid,
        xid: localStorage.xid,
      },
      uploadModel: false,
      uploadTypeName: "BIM模型",
      uploadType: 1,
      zwpd01: "",
      zjwj_planrecord: {
        zwpr01: "",
        zwpr02: "",
        zwpr03: localStorage.id,
        zwpr04: 0,
        zwpr05: "",
        zwpr06: new Date(),
      },
      jindu: 0,
      recordList: [],
      record: false,
      addRecord: false,
      list: [],
      planid: "",
      searchword: "",
      tableList: [],
      type: 1,
      loading: false,
      input: "",
      dialogTableVisible: false,
      time: new Date().toLocaleString("chinese", { hour12: false }),
      progressNumber: 20,
      polar: {},
      polar1: {},
      polar2: {},
      model1Nanme: "",
      model1Path: "",
      model2Nanme: "",
      model2Path: "",
      model1: "",
      model2: "",
      loading2: null,
      bhMsg: "",
      //--
      palnDetailid: "",
      fzId: "",
    };
  },
  async created() {
    this.GetZjwjProjectPlan();
  },
  mounted() {
    setInterval(() => {
      this.time = new Date().toLocaleString("chinese", { hour12: false });
    }, 1000);
  },
  methods: {
    async uploadQLHModel() {
      this.uploadLoading = true;
      let fd = new FormData();
      let file1 = this.fileList.filter((ele) => ele.name == "file1")[0].value;
      let file2 = this.fileList.filter((ele) => ele.name == "file2")[0].value;
      if (file1 && file2) {
        fd.append("file1", file1);
        fd.append("file2", file2);
        Object.keys(this.ziwj_planmodel).forEach((ele) => {
          fd.append(ele, this.ziwj_planmodel[ele]);
        });
        let res = await ZjwjUploadModelFile(fd);
        this.fileList = [];
        this.uploadLoading = false;
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "上传成功",
          });
        } else {
          this.$message({
            type: "success",
            message: "上传失败",
          });
        }
        this.ziwj_planmodel = {
          zwpm01: "",
          zwpm02: "",
          zwpm03: "",
          zwpm04: "",
          zwpm05: "",
          zwpm06: localStorage.id,
          zwpm07: new Date(),
          zwpm08: "",
          cid: localStorage.pid,
          xid: localStorage.xid,
        };
        this.uploadModel = false;
        this.uploadModelType = false;
        this.GetZjwjPlanModel();
      } else {
        this.$message({
          type: "warning",
          message: "请选择完整文件上传",
        });
      }
    },
    uploadChange(file) {
      let object = {
        name: "file1",
        value: file.raw,
      };
      this.fileList.push(object);
    },
    uploadChange2(file) {
      let object = {
        name: "file2",
        value: file.raw,
      };
      this.fileList.push(object);
    },
    updataModelShow() {
      this.uploadModel = true;
      this.uploadType = 1;
    },
    updataModelShowREVIT() {
      this.uploadType = 2;
      this.uploadModel = true;
    },
    ModelCompare() {
      if (this.model1 == "" || this.model2 == "") {
        this.$message({
          type: "warning",
          message: "请选择模型",
        });
      } else {
        if (!this.model1Path == this.model2Path) {
          this.$message({
            type: "warning",
            message: "请选择不同的模型进行比对",
          });
        } else if (modelCompare.viewer1IsLoad && modelCompare.viewer2IsLoad) {
          var length = modelCompare.getViewerLenth();
          var msg = `${this.model1Nanme}（模型1）共有<b>${length[0]}</b>个构件,${this.model2Nanme}（模型2）共有<b>${length[1]}</b>个构件,是否进行比对？`;
          if (length[0] > 10000 || length[1] > 10000) {
            msg = `${this.model1Nanme}（模型1）共有<b>${length[0]}</b>个构件,${this.model2Nanme}（模型2）共有<b>${length[1]}</b>个构件,
             检测到模型较大，比对时间较长，是否进行比对？`;
          }
          this.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
          }).then(() => {
            this.openFullScreen2();
            modelCompare.ModelCompare();
            var _Interval = setInterval(() => {
              if (modelCompare.compareComplete) {
                window.clearInterval(_Interval);
                this.loading2.close();
                this.$message({
                  type: "success",
                  message: "比对完成",
                });
              }
            }, 1000);
          });
        } else {
          this.$message({
            type: "warning",
            message: "请等待模型加载完毕",
          });
        }
      }
    },
    openFullScreen2() {
      this.loading2 = this.$loading({
        lock: true,
        text: "比对中，请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    model1Change(val) {
      this.model1Nanme = val.zwpm03;
      this.model1Path = val.zwpm04;
      var path = this.$store.state.baseUrl + val.zwpm04;
      modelCompare.viewer1Load(path);
    },
    model2Change(val) {
      this.model2Nanme = val.zwpm03;
      this.model2Path = val.zwpm04;
      var path = this.$store.state.baseUrl + val.zwpm04;
      modelCompare.viewer2Load(path);
    },
    modelDuibi(type) {
      if (type === 1) {
        this.modelisShow = false;
        this.modelDB = true;
      } else {
        this.modelisShow = true;
        this.modelDB = false;
      }
    },
    async AddCrashCheck() {
      this.zjwj_crashcheck.zwcc04 = JSON.stringify(
        CrashCheck.resultTree.getNodes()
      );
      if (this.zjwj_crashcheck.zwcc04.length === 0) {
        this.$message({
          type: "warning",
          message: "当前暂无碰撞数据",
        });
        return;
      }
      let res = await AddCrashCheck({ model: this.zjwj_crashcheck });
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: "上传成功",
        });
        this.AddCrashCheckIsShow = false;
      }
    },
    AddCrashCheckOpen() {
      this.AddCrashCheckIsShow = true;
    },
    async GetCrashCheck() {
      let params = {
        id: this.zwpm01,
      };
      let res = await GetCrashCheck({ params });
      if (res.Data.length > 0) {
        CrashCheck.initCrashCheckBaoGao(res.Data);
      }
    },
    viewpointSave() {
      ZJWJViewPoint.init(ZJWJ.viewer, ZJWJ.modelData);
    },
    pengzhuang() {
      CrashCheck.init(ZJWJ.viewer);
    },
    viewModel(data) {
      this.modelisShow = true;
      this.isDocumentShow = false;
      this.zwpm01 = data.zwpm01;
      this.zjwj_crashcheck.zwcc02 = data.zwpm01;
      this.zjwj_crashcheck.zwcc06 = data.zwpm06;
      if (data.zwpm08 === 3) {
        this.isTuZhi = true;
      }
      var data = {
        url: this.$store.state.baseUrl + data.zwpm04,
        modelId: data.zwpm01,
        cid: localStorage.pid,
        xid: localStorage.xid,
        type: 1,
      };
      this.viewers2(data);
    },
    viewers2(data) {
      this.modelLoad = false;
      this.$nextTick(() => {
        ZJWJ.LoadModel(data);
        var Interval = setInterval(() => {
          if (ZJWJ.modelLoad) {
            clearInterval(Interval);
            this.modelLoad = true;

            Fcis.Fc(".lll", "#div_viewpoint");
            Fcis.Fc(".lll", "#crashCheckDiv");
          }
        }, 500);
      });
    },
    viewFileAudit(data) {
      this.bianjiAudit = true;
      this.zwfa03 = data.zwfa03;
    },
    async viewDocument(data) {
      this.isDocumentShow = true;
      this.modelisShow = false;
      if (
        data.zwpm04
          .split(".")
          [data.zwpm04.split(".").length - 1].toLowerCase() == "pdf"
      ) {
        this.iframeUrl = this.$store.state.baseUrl + data.zwpm04;
      } else {
        let res = await Office2Pdf({ sourcePath: data.zwpm04 });
        if (res.Code === 0) {
          this.$message({
            type: "warning",
            message: "占不支持此类型文件在线查看，请点击下载查看",
          });
        } else {
          this.iframeUrl = this.$store.state.baseUrl + res.Data;
        }
      }
      let res2 = await GetFileAudit({
        params: { id: data.zwpm01 },
      });
      this.fileAuditList = res2.Data;
    },
    changeBohui(data) {
      let obj = this.bohuiList.find((ele) => ele.zwpa01 === data);
      this.ModelList = obj.ModelList;
      this.FileList = obj.FileList;
      this.DrawList = obj.DrawList;
      this.bhMsg = obj.zwpa04;
    },
    async GetPlanAuditOpen(data) {
      this.GetPlanAuditIsShow = true;
      this.isDocumentShow = false;
      this.modelisShow = false;
      let res = await GetPlanAudit({ params: { id: data.zwpd01 } });
      if (res.Data.length > 0) {
        this.bohuiList = res.Data;
        this.bohuiId = res.Data[0].zwpa01;
        this.ModelList = res.Data[0].ModelList;
        this.FileList = res.Data[0].FileList;
        this.DrawList = res.Data[0].DrawList;
        this.bhMsg = res.Data[0].zwpa04;
      } else {
        this.$message({
          type: "warning",
          message: "暂无驳回信息",
        });
      }
    },
    // 高亮
    tableRowClassName({ row, rowIndex }) {
      if (row.zwpd01 == this.palnDetailid) {
        return "success-row";
      }
      return "";
    },
    viewModelOpen(data) {
      this.viewModelIsShow = true;
      this.modelUrl = this.$store.state.baseUrl + data.zwpm04;
      var data = {
        url: this.modelUrl,
        modelId: data.zwpm01,
        cid: localStorage.pid,
        xid: localStorage.xid,
        type: 1,
      };
      this.viewers(data);
    },
    viewers(data) {
      this.$nextTick(() => {
        ZJWJ.LoadModel(data);
      });
    },
    downloadModel(data) {
      if (data.downPath) {
        let aNode = document.createElement("a");
        aNode.target = "_blank";
        aNode.href = `${this.$store.state.baseUrl}/api/PlanFileDownLoad?id=${data.zwpm01}&name=${data.zwpm03}&token=${localStorage.token}`;
        aNode.click();
      } else {
        this.$message({
          type: "warning",
          message: "无法下载",
        });
      }
    },
    DelZjwjPlanModel(data) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let params = {
          id: data.zwpm01,
        };
        let res = await DelZjwjPlanModel(params);
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.GetZjwjPlanModel();
        }
      });
    },
    uploadSuccess(res) {
      if (res.Code > 0) {
        // this.$confirm
        this.$message({
          type: "success",
          message: "上传成功",
        });
        this.GetZjwjPlanModel();
      } else {
        this.$message({
          type: "warning",
          message: "上传失败",
        });
      }
      this.uploadLoading = false;
      this.uploadModel = false;
      this.uploadModelType = false;
      this.GetZjwjPlanModel();
    },
    beforeUpload(file) {
      if (this.uploadType === 2) {
        this.$confirm(
          "模型正在排队装换中，可能需要很长时间，您可以选择关闭该页面离开，系统会自动完成后续轻量化过程。请问是否离开？",
          "提示",
          {
            confirmButtonText: "离开",
            cancelButtonText: "继续等待",
            type: "warning",
          }
        )
          .then(() => {
            this.$message({
              // type: 'success',
              message: "您已离开!",
            });
            this.uploadLoading = false;
            this.uploadModel = false;
            // this.uploadModel = false;
            this.dialogTableVisible = false;
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "继续等待",
            });
            this.uploadLoading = true;
          });
      }
      if (this.uploadType === 1 || this.uploadType === 3) {
        var ext = file.name
          .substring(file.name.lastIndexOf(".") + 1)
          .toLowerCase();
        const iszip = ext == "zip" || ext == "svfzip";
        if (!iszip) {
          this.$message.error("上传文件只能是 zip/svfzip 格式!");
          this.uploadLoading = false;
        }
        return iszip;
      }
      if (this.uploadType === 4) {
        var ext = file.name
          .substring(file.name.lastIndexOf(".") + 1)
          .toLowerCase();
        // doc docx xls xlsx ppt pptx pdf
        const iszip =
          ext == "doc" ||
          ext == "docx" ||
          ext == "xls" ||
          ext == "xlsx" ||
          ext == "ppt" ||
          ext == "pptx" ||
          ext == "pdf";
        if (!iszip) {
          this.$message.error(
            "上传文件只能是 doc/docx/xls/xlsx/ppt/pptx/pdf 格式!"
          );
          this.uploadLoading = false;
        }
        return iszip;
        this.uploadLoading = false;
      }
    },
    uploadModelOpen() {
      this.ziwj_planmodel.zwpm02 = this.zwpd01;
      this.ziwj_planmodel.zwpm08 = this.uploadType;
      if (this.uploadType == 1 || this.uploadType == 3) {
        this.uploadModelType = true;
      } else {
        this.uploadModel = true;
      }
    },
    changUploadType(data) {
      this.uploadType = data;
      switch (data) {
        case 1:
          this.uploadTypeName = "BIM模型";
          break;
        case 3:
          this.uploadTypeName = "CAD图纸";
          break;
        default:
          this.uploadTypeName = "文档";
      }
      this.GetZjwjPlanModel();
    },
    dialogTableVisibleOpen(data) {
      this.dialogTableVisible = true;
      this.zwpd01 = data.zwpd01;
      this.GetZjwjPlanModel();
    },
    async GetZjwjPlanModel() {
      this.uploadListLoading = true;
      let params = {
        id: this.zwpd01,
        type: this.uploadType,
      };
      let res = await GetZjwjPlanModel({ params });
      this.uploadList = res.Data;
      this.uploadListLoading = false;
    },
    AddZjwjPlanRecordOpen() {
      this.addRecord = true;
    },
    async AddZjwjPlanRecord() {
      let params = {
        model: this.zjwj_planrecord,
      };
      let res = await AddZjwjPlanRecord(params);
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: "添加成功",
        });
        this.GetZjwjPlanRecord();
        this.addRecord = false;
      }
    },
    async openRecord(data) {
      this.fzId = data.fzId;
      this.record = true;
      this.zjwj_planrecord.zwpr02 = data.zwpd01;
      this.zwpd01 = data.zwpd01;
      this.GetZjwjPlanRecord();
    },
    async GetZjwjPlanRecord() {
      let params = {
        id: this.zwpd01,
      };
      let res = await GetZjwjPlanRecord({ params });
      this.recordList = res.Data;
    },
    async ZjwjStartPlan(data) {
      let params = {
        id: data.zwpd01,
        type: 1,
      };
      let res = await ZjwjStartPlan(params);
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: "启动成功",
        });
        this.ZjwjMyToDo();
      }
    },
    changeType(data) {
      this.type = data;
      this.loading = true;
      this.ZjwjMyToDo();
    },
    changePlanid() {
      this.ZjwjMyToDo();
      this.initEcharts();
    },
    async GetZjwjProjectPlan() {
      let params = {
        id: localStorage.xid,
        searchword: "",
        pageIndex: 1,
        type: 1,
        pageSize: 100000000,
        type: 1,
      };
      let res = await GetZjwjProjectPlan({ params });
      if (res.Data.list.length > 0) {
        this.list = res.Data.list;
        this.planid = this.list[0].zwpp01;
        this.loading = true;
        if (this.$route.params.id) {
          this.planid = this.$route.params.id;
          this.palnDetailid = this.$route.params.palnDetailid;
        }
        this.ZjwjMyToDo();
        this.initEcharts();
      }
    },
    async initEcharts() {
      this.resetEchartsData();
      // 这里是查找全部的数据
      let params2 = {
        xid: localStorage.xid,
        planid: this.planid,
        uid: localStorage.getItem("id"),
        searchword: this.searchword,
        type: 0,
      };
      let res2 = await ZjwjMyToDo({ params: params2 });
      let result = res2.Data;
      this.jisuan(result);
      this.GetZjwjMyFile();
      this.polar = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "right",
          right: "10px",
          data: [
            "未启动(正常)",
            "未启动延期",
            "执行中(正常)",
            "执行中延期",
            "已完成(正常)",
            "已完成延期",
          ],
        },
        series: [
          {
            name: "数据来源",
            type: "pie",
            radius: "40%",
            center: ["35%", "30%"],
            label: {
              // position:'inside'
            },
            data: [
              { value: this.wqdzc, name: "未启动(正常)" },
              { value: this.wqdyq, name: "未启动延期" },
              { value: this.zxzzc, name: "执行中(正常)" },
              { value: this.zxzyq, name: "执行中延期" },
              { value: this.ywczc, name: "已完成(正常)" },
              { value: this.ywcyq, name: "已完成延期" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              //去除饼图的指示折线label
              normal: {
                show: false,
                position: "inside",
                formatter: "{b}:{d}%",
              },
            },
          },
        ],
      };
      this.polar1 = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "right",
          right: "10px",
          data: ["正常进行", "延期"],
        },
        series: [
          {
            name: "数据来源",
            type: "pie",
            radius: "40%",
            center: ["35%", "30%"],
            label: {
              // position:'inside'
            },
            data: [
              { value: this.zxzzc, name: "正常进行" },
              { value: this.yiyanqi, name: "延期" },
            ],
            label: {
              //去除饼图的指示折线label
              normal: {
                show: false,
                position: "inside",
                formatter: "{b}:{d}%",
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      this.polar2 = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "right",
          right: "10px",
          data: ["正常任务项", "风险预警项"],
        },
        series: [
          {
            name: "数据来源",
            type: "pie",
            radius: "40%",
            center: ["35%", "30%"],
            label: {
              // position:'inside'
            },
            data: [
              { value: this.zcrw, name: "正常任务项" },
              { value: this.wxrw, name: "风险预警项" },
            ],
            label: {
              //去除饼图的指示折线label
              normal: {
                show: false,
                position: "inside",
                formatter: "{b}:{d}%",
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
    },
    resetEchartsData() {
      this.myFileData = [];
      this.zong = 0;
      this.weiqi = 0;
      this.jinxing = 0;
      this.yiyanqi = 0;
      this.yiwancheng = 0;
      this.wqdzc = 0;
      this.wqdyq = 0;
      this.zxzzc = 0;
      this.zxzyq = 0;
      this.ywczc = 0;
      this.ywcyq = 0;
      this.wxrw = 0;
      this.zcrw = 0;
    },
    async GetZjwjMyFile() {
      let params = {
        id: this.planid,
        uid: localStorage.id,
      };
      let res = await GetZjwjMyFile({ params });
      this.myFileData = res.Data;
    },
    jisuan(data) {
      data.forEach((ele) => {
        if (ele.children.length > 0) {
          this.jisuan(ele.children);
        }
        if (ele.children.length === 0) {
          this.zong++;
          switch (ele.state) {
            case "未启动正常":
              this.weiqi++;
              this.wqdzc++;
              break;
            case "未启动延期":
              this.weiqi++;
              this.yiyanqi++;
              this.wqdyq++;
              break;
            case "进行中正常":
              this.jinxing++;
              this.zxzzc++;
              break;
            case "进行中延期":
              this.jinxing++;
              this.yiyanqi++;
              this.zxzyq++;
              break;
            case "已完成正常":
              this.yiwancheng++;
              this.ywczc++;
              break;
            case "已完成延期":
              this.yiwancheng++;
              this.yiyanqi++;
              this.ywcyq++;
              break;
          }
          switch (ele.isDanger) {
            case 0:
              this.zcrw++;
              break;
            case 1:
              this.wxrw++;
              break;
          }
        }
      });
    },
    async ZjwjMyToDo() {
      let params = {
        xid: localStorage.xid,
        planid: this.planid,
        uid: localStorage.getItem("id"),
        searchword: this.searchword,
        type: this.type,
      };
      let res = await ZjwjMyToDo({ params });
      this.tableList = res.Data;
      this.initData(this.tableList);
      this.loading = false;
    },
    initData(data) {
      data.forEach((ele) => {
        ele.fzId = ele.fzList.length > 0 ? ele.fzList[0].user01 : "";
        ele.shId = ele.shList.length > 0 ? ele.shList[0].user01 : "";
        ele.fzr = [];
        ele.fzList.forEach((ele2) => {
          ele.fzr.push(ele2.user04);
        });
        ele.fzr = ele.fzr.join(",");
        ele.shr = [];
        ele.shList.forEach((ele2) => {
          ele.shr.push(ele2.user04);
        });
        ele.shr = ele.shr.join(",");
        if (ele.children.length > 0) {
          this.initData(ele.children);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.changUpload {
  height: 50vh;
  text-align: center;
  .ZIP {
    width: 35%;
    height: 75%;
    margin-left: 10%;
    float: left;
    border: 2px solid #eee;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;
    p {
      font-size: 14px;
      margin-top: 30px;
      height: 50px;
    }
    img {
      width: 100px;
      margin-top: 50px;
    }
  }
  .ZIP:hover {
    background: #eee;
    border-color: skyblue;
  }
  .REVIT:hover {
    background: #eee;
    border-color: skyblue;
  }
  .REVIT {
    width: 35%;
    height: 75%;
    float: left;
    margin-left: 5%;
    border: 2px solid #eee;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;
    p {
      font-size: 14px;
      margin-top: 30px;
      height: 50px;
    }
    img {
      width: 100px;
      margin-top: 50px;
    }
  }
}
.model {
  position: fixed;
  width: 100%;
  height: 90%;
}
.flex {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.flexbetween {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex_al_jc {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex_fd {
  display: flex;
  flex-direction: column;
}
/deep/.el-table .success-row {
  background: skyblue;
}
/deep/ .el-collapse-item__header {
  font-size: 18px;
}
</style>

<style lang="less" scoped>
.model {
  position: relative;
  width: 100%;
  height: 100%;
}
.flex {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.flexbetween {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex_al_jc {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex_fd {
  display: flex;
  flex-direction: column;
}
.ModelCompare {
  width: 100%;
  height: 700px;
  position: relative;
  .model {
    width: 50%;
    position: absolute;
    height: 700px;
  }
  .model3 {
    left: 50%;
    width: 50%;
  }
  .myborder-el-button {
    position: absolute;
    top: 20%;
    left: -0.5rem;
    z-index: 99;
    background: #fff;
    color: #00bcd4;
    border: 0.25rem solid #00bcd4;
    font-size: 2rem;
  }

  .divs {
    width: 50px;
    font-size: 14px;
    text-align: center;
    position: absolute;
    height: 150px;
    padding-top: 50px;
    margin-top: 2rem;
    z-index: 9;
    background: #00bcd4;
    border-radius: 0 0 10px 10px;
    div {
      width: 88%;
      height: 22px;
      border-radius: 2px;
      margin: 10px auto;
      cursor: pointer;
      &:nth-child(1) {
        background-color: rgb(255, 0, 0);
      }
      &:nth-child(2) {
        background-color: rgb(0, 128, 0);
      }
      &:nth-child(3) {
        background-color: rgb(218, 165, 32);
        color: #000000;
      }
      &:nth-child(4) {
        color: #000000;
        background-color: rgb(255, 255, 0);
      }
    }
  }
  .myBorder {
    z-index: 999;
    position: absolute;
    left: 49%;
    height: 700px;
    background: #00bcd4;
    color: #fff;
    font-size: 18px;
    display: flex;
    align-items: center;
  }
  .modelListOne {
    position: absolute;
    z-index: 999;
    top: 2%;
    left: 2%;
  }
  .modelListTwo {
    position: absolute;
    z-index: 999;
    top: 2%;
    left: 52%;
  }
}
/* 新增 */
</style>

<style lang="less" scoped>
@import url("../../../../public/Content/css/style.css");
#My2DViewerDiv {
  height: 95%;
  width: 100%;
  position: absolute;
}
.body_viewpoint {
  overflow: hidden;
  height: 91% !important;
  overflow-y: auto;
}
.body_viewpoint .treeDemo_viewpoint {
  width: 100%;
  height: 100%;
  border: none;
}
.layer-background {
  background: rgba(255, 255, 255, 0.8) !important;
}
.liveBarCodeShow {
  z-index: 10;
  position: absolute;
  width: 410px;
  // background: #eee;
}
.search-input {
  width: 140px;
}
.back {
  background: #eee;
}
#middle1 {
  width: 0;
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 10;
  border-left: 18px dashed transparent;
  margin-left: -9px;
  cursor: e-resize;
  display: none;
}

.reflex-layout.reflex-container {
  -ms-flex-pack: start;
  justify-content: flex-start;
  -ms-flex-align: stretch;
  align-items: stretch;
  -ms-flex-line-pack: stretch;
  align-content: stretch;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  height: 100%;
  width: 100%;
}
.reflex-layout.reflex-container.horizontal {
  -ms-flex-direction: column;
  flex-direction: column;
}
.reflex-layout.reflex-container.vertical {
  -ms-flex-direction: row;
  flex-direction: row;
}
.reflex-layout > .reflex-element {
  position: relative;
  overflow: auto;
  height: 100%;
  width: 100%;
}
.reflex-layout > .reflex-splitter {
  background-color: #eee;
  z-index: 100;
}
.reflex-layout > .reflex-splitter.active,
.reflex-layout > .reflex-splitter:hover {
  background-color: #c6c6c6;
  transition: all 1s ease;
}
.reflex-layout.horizontal > .reflex-splitter {
  border-bottom: 1px solid #c6c6c6;
  border-top: 1px solid #c6c6c6;
  cursor: row-resize;
  width: 100%;
  height: 2px;
}
.reflex-layout.horizontal .reflex-handle {
  cursor: row-resize;
}
.reflex-layout.horizontal > .reflex-splitter.active,
.reflex-layout.horizontal > .reflex-splitter:hover {
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}
.reflex-layout.vertical > .reflex-splitter {
  border-right: 1px solid #c6c6c6;
  border-left: 1px solid #c6c6c6;
  cursor: col-resize;
  height: 100%;
  width: 2px;
}
.reflex-layout.vertical .reflex-handle {
  cursor: col-resize;
}
.reflex-layout.vertical > .reflex-splitter.active,
.reflex-layout.vertical > .reflex-splitter:hover {
  border-right: 1px solid #eee;
  border-left: 1px solid #eee;
}
.reflex-layout > .reflex-splitter.reflex-thin {
  box-sizing: border-box;
  background: #000;
  background-clip: padding-box;
  opacity: 0.2;
  z-index: 100;
}
.reflex-layout
  > .reflex-splitter.reflex-thin.active
  .reflex-layout
  > .reflex-splitter.reflex-thin:hover {
  transition: all 1.5s ease;
  opacity: 0.5;
}
.reflex-layout.horizontal > .reflex-splitter.reflex-thin {
  border-bottom: 8px solid hsla(0, 0%, 100%, 0);
  border-top: 8px solid hsla(0, 0%, 100%, 0);
  height: 17px !important;
  cursor: row-resize;
  margin: -8px 0;
  width: 100%;
}
.reflex-layout.horizontal > .reflex-splitter.reflex-thin.active,
.reflex-layout.horizontal > .reflex-splitter.reflex-thin:hover {
  border-bottom: 8px solid #e4e4e4;
  border-top: 8px solid #e4e4e4;
}
.reflex-layout.vertical > .reflex-splitter.reflex-thin {
  border-right: 8px solid hsla(0, 0%, 100%, 0);
  border-left: 8px solid hsla(0, 0%, 100%, 0);
  width: 17px !important;
  cursor: col-resize;
  margin: 0 -8px;
  height: 100%;
}
.reflex-layout.vertical > .reflex-splitter.reflex-thin.active,
.reflex-layout.vertical > .reflex-splitter.reflex-thin:hover {
  border-right: 8px solid #e4e4e4;
  border-left: 8px solid #e4e4e4;
}
/deep/ .dropdown-ul li {
  width: 9.3%;
}
#menu_crashCheck_content_box .menu_table .box {
  width: 45%;
  margin-left: 2%;
  float: left;
  height: 85%;
  margin-bottom: 4px;
}
/deep/ .crashCheck_box {
  height: 700px;
  width: 300px;
  position: fixed;
  top: 10%;
  left: 60%;
  background: rgba(255, 255, 255);
}
/deep/ .el-upload {
  width: 100%;
}
#menu_crashCheck_content_box .menu_table .todo {
  line-height: 33px;
}
#menu_crashCheck_content_box .menu_table .box .export {
  line-height: 23px;
  margin: 0;
}
#div_viewpoint .body_viewpoint {
  max-height: 91%;
}
#sideMenuContainer,
#asideChatView,
#div_viewpoint {
  background: rgba(255, 255, 255);
}
.box_title {
  height: 3%;
}
.tab_title {
  height: 5%;
}
#menu_crashCheck_content_box {
  height: 92%;
}
.box_content {
  height: 97%;
}
.ztree {
  padding: 0px;
}
</style>
<style scoped>
.sdbcName {
  font-size: 20px;
  font-weight: 300;
  cursor: all-scroll;
}
.btnSearch {
  position: absolute;
  left: 0;
}
.pos-re-left4 {
  position: relative;
  left: 4px;
}
.clo1 {
  font-weight: 300;
  position: absolute;
  right: 0;
  color: #c3c3c3;
  font-size: 16px;
}
.w-h-bg-cor {
  height: 40px;
}
#vp-btn-mark {
  margin: 1px 0 0 66px;
  display: inline-block;
}
#vp-btn-save {
  display: inline-block;
}
.dis-none {
  display: none;
}
.rMenu {
  visibility: hidden;
}
.pos-fixed {
  position: fixed;
}
.dis-lis-item {
  /* display: inline-block; */
}
.filter_box {
  cursor: default;
  display: none;
}
.dis-bok {
  display: block;
}
.mar-top3 {
  margin-top: 3%;
}
.crashCheck_box {
  cursor: default;
}
.gray {
  opacity: 0;
}
.height40p {
  height: 40px;
}
.width100 {
  width: 100%;
}
#vp-searchtxt {
  padding-left: 20px;
}
</style>
